import React, { createRef, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import _ from 'lodash';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';

SetKPIView.propTypes = {
    item: PropTypes.object,
    onSubmit: PropTypes.func,
    isDefaultKPI: PropTypes.bool,
};

const ref = createRef();

function SetKPIView(props) {
    // ---- params ----
    const { item, onSubmit, isDefaultKPI = true } = props;
    const refFormik = useRef();
    const { t } = useTranslation();
    const [totalKPI, setTotalKPI] = useState(0);
    const currentMonth = moment().format('YYYY-MM');

    const monthKPIValues = useMemo(() => {
        const findValue = (type) => item?.kpis?.find(kpi => kpi?.orderType === type && kpi?.month === currentMonth)?.kpiValue ?? 0;
        return {
            saleKPI: findValue('INVESTOR'),
            packageKPI: findValue('GROUP'),
            chargePointKPI: findValue('CHARGEPOINT'),
        }
    }, [item])

    const initialValues = useMemo(() => {
        return {
            saleKPI: isDefaultKPI ? item?.saleKPI : monthKPIValues.saleKPI,
            packageKPI: isDefaultKPI ? item?.packageKPI : monthKPIValues.packageKPI,
            chargePointKPI: isDefaultKPI ? item?.chargePointKPI : monthKPIValues.chargePointKPI,
        }
    }, [item, isDefaultKPI, monthKPIValues])

    useEffect(() => {
        const { saleKPI, packageKPI, chargePointKPI } = initialValues;
        setTotalKPI(Number(saleKPI) + Number(packageKPI) + Number(chargePointKPI));
    }, [initialValues]);

    useEffect(() => {
        ref.current = {
            onSubmit: () => {
                refFormik.current?.handleSubmit();
            },
        };

        return () => { };
    }, []);

    // ---- methods ----

    const handleChangeKPI = (field, value, formikValues) => {
        const updated = { ...formikValues, [field]: Number(value) };
        const newTotal = Number(updated.saleKPI) + Number(updated.packageKPI) + Number(updated.chargePointKPI);
        setTotalKPI(newTotal);
    }

    return (
        <div className="w-100">
            <Formik
                initialValues={initialValues}
                validationSchema={Yup.object({
                    saleKPI: Yup.number().required(t('required')).min(0, t('invalid')),
                    packageKPI: Yup.number().required(t('required')).min(0, t('invalid')),
                    chargePointKPI: Yup.number().required(t('required')).min(0, t('invalid')),
                })}
                enableReinitialize
                onSubmit={(values) => {
                    if (onSubmit) {
                        onSubmit(values);
                    }
                }}
            >
                {(formikProps) => {
                    refFormik.current = formikProps;

                    const renderInput = (name, label) => (
                        <div className="col-12 p-0 mt-4">
                            <KTFormGroup
                                label={<span className="font-weight-bolder">{label} </span>}
                                inputName={name}
                                additionalClassName="mb-0"
                                inputElement={
                                    <Field name={name}>
                                        {({ field, form, meta }) => (
                                            <KTFormInput
                                                name={field.name}
                                                value={field.value}
                                                onChange={(value) => {
                                                    form.setFieldValue(field.name, value);
                                                    handleChangeKPI(field.name, value, formikProps.values);
                                                }}
                                                onBlur={() => {
                                                    form.setFieldTouched(field.name, true);
                                                }}
                                                enableCheckValid
                                                type={KTFormInputType.currency}
                                                placeholder={t('enterNumber')}
                                                isValid={_.isEmpty(meta.error)}
                                                isTouched={meta.touched}
                                                feedbackText={meta.error}
                                            />
                                        )}
                                    </Field>
                                }
                                isRequired={true}
                            />
                        </div>
                    );

                    return (
                        <div className="row m-0 w-100">
                            {renderInput('packageKPI', t('KPI bán gói đầu tư HTKD'))}
                            {renderInput('saleKPI', t('KPI bán nhượng quyền'))}
                            {renderInput('chargePointKPI', t('KPI bán trụ sạc'))}

                            <div className="col-12 p-0 mt-4">
                                <KTFormGroup
                                    label={<span className="font-weight-bolder">{t('Tổng mức KPI thiết lập')} </span>}
                                    inputName="totalKPI"
                                    additionalClassName="mb-0"
                                    inputElement={
                                        <KTFormInput
                                            name="totalKPI"
                                            value={totalKPI}
                                            onChange={() => { }}
                                            enableCheckValid
                                            type={KTFormInputType.currency}
                                            placeholder={t('enterNumber')}
                                            isValid={true}
                                            disabled={true}
                                        />
                                    }
                                />
                            </div>
                        </div>
                    );
                }}
            </Formik>
        </div>
    );
}
export default SetKPIView;
export const SetKPIViewHelper = {
    onSubmit: () => {
        ref.current.onSubmit();
    },
};
